import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'profiles',
    component: () => import('@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'profiles-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {                           
                        transKey: 'breadcrumbs.profiles-index',
                        isActive: true
                    }
                ]
            },
            component: () => import('@/modules/configurations/profiles/views/Index.vue')
        },
        {
            path: 'create',
            name: 'profiles-create',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {   
                        route: {
                            name: 'profiles-index',
                            params: {}
                        },
                        transKey: 'breadcrumbs.profiles-index',
                        isActive: false
                    },
                    {                           
                        transKey: 'breadcrumbs.profiles-create',
                        isActive: true
                    }
                ]
            },
            component: () => import('@/modules/configurations/profiles/views/Create.vue')
        },
        {
            path: 'edit/:id',
            name: 'profiles-edit',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {   
                        route: {
                            name: 'profiles-index',
                            params: {}
                        },
                        transKey: 'breadcrumbs.profiles-index',
                        isActive: false
                    },
                    {                           
                        transKey: 'breadcrumbs.profiles-edit',
                        isActive: true
                    }
                ]
            },
            component: () => import('@/modules/configurations/profiles/views/Edit.vue')
        }
    ]
}